import { Injectable } from '@angular/core';
declare var $: any;

@Injectable()
export class FaviconService {
  setAppFavicon(icon: string) {
    $('#appIcon').attr('href', icon);
  }
}
